import { ApplicationUsers } from "./application-users.component";
import { ApplicationUser } from "./application-user.component";
import { EditApplicationUser } from "./application-user.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { applicationUsersState, applicationUserState, newApplicationUserState, editApplicationUserState } from "./application-users.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let STATES = [applicationUsersState, applicationUserState, newApplicationUserState, editApplicationUserState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    declarations: [ApplicationUsers, ApplicationUser, EditApplicationUser],
    entryComponents: [ConfirmDialog]
})
export default class ApplicationUsersModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/applicationusers/application-users.module.ts